





























import BusinessHoursSelection from '@/features/bots/components/businessHoursSelection/BusinessHoursSelection.vue';
import { Component, Prop, Vue } from 'vue-property-decorator';
import { ConditionViewModel } from '../models/conditionViewModel';
import { BusinessHoursViewModel } from '@/features/bots/models';
import { BusinessHoursOptions } from '@/features/bots/components/businessHoursSelection';

export enum ScheduleType {
	InHours,
	OutOfHours,
	CustomTimes
}

@Component({
	components: {
		BusinessHoursSelection
	}
})
export default class TimeOfDayCondition extends Vue {
	@Prop() public condition: ConditionViewModel;

	public customTimes: BusinessHoursViewModel[] = [];
	public scheduleType: ScheduleType = ScheduleType.InHours;

	public timeOfDayOptions = [
		{ value: ScheduleType.InHours, label: 'In hours' },
		{ value: ScheduleType.OutOfHours, label: 'Out of hours' },
		{ value: ScheduleType.CustomTimes, label: 'Custom' }
	];

	public liveCondition: ConditionViewModel = {
		attribute: '',
		operation: '',
		type: '',
		value: '',
		result: true
	};

	public mounted() {
		this.liveCondition = this.condition;
		this.setConditionType();
		this.handleSelectionChange(this.scheduleType);
	}

	public handleSelectionChange(type: ScheduleType): void {
		this.scheduleType = type;
		if (type === ScheduleType.InHours) {
			this.selectInHours();
		} else if (type === ScheduleType.OutOfHours) {
			this.selectInHours(false);
		} else if (type === ScheduleType.CustomTimes) {
			this.selectCustomSchedule();
		}
		this.$emit('changed', this.liveCondition);
	}

	public customScheduleChanged() {
		this.liveCondition.result = true;
		this.liveCondition.value = JSON.stringify(this.customTimes);
		this.$emit('changed', this.liveCondition);
	}

	public customScheduleInvalid(invalid: boolean) {
		this.liveCondition.invalid = invalid;
	}

	public complete() {
		this.$emit('completed', this.liveCondition);
	}

	private selectInHours(isInHours: boolean = true) {
		this.liveCondition = {
			attribute: this.condition.attribute,
			operation: 'in',
			type: this.condition.type,
			value: 'bot.openingTimes',
			result: isInHours,
			unit: this.condition.unit,
			invalid: false
		};
	}

	private setConditionType() {
		if (!this.liveCondition.value) {
			return;
		}
		if (this.liveCondition.value === 'bot.openingTimes') {
			this.scheduleType = this.liveCondition.result ? ScheduleType.InHours : ScheduleType.OutOfHours;
		} else {
			this.scheduleType = ScheduleType.CustomTimes;
		}
	}

	private selectCustomSchedule() {
		this.liveCondition.result = true;
		try {
			this.customTimes = JSON.parse(this.liveCondition.value);
		} catch {
			this.customTimes = [BusinessHoursOptions.getDefaultModel()];
			this.liveCondition.value = JSON.stringify([BusinessHoursOptions.getDefaultModel()]);
		}
	}
}
